import React from 'react';
import CreditCard from './CreditCard';
import Page from '../../layout/Page';
import Email from './Email';
import Header from './Header';
import Logo from './Logo';
import { userRoles } from '../../RoleProtected';
import UserManagement from './UserManagement';
import LPRSettings from './LPRSettings';
import { Features } from '../../RequireFeature';

const Settings = ({ ...props }) => {

    return (
        <Page
            title='Settings'
            icon='cog'
            tabs
        >
            <CreditCard tab='Credit Card' roles={userRoles.accountConfiguration} />

            <Email tab='Email Setup' roles={userRoles.accountConfiguration} />

            <Header tab='Header' roles={userRoles.accountConfiguration} />

            {/* <LocationManagement tab='Location Management' roles={userRoles.admin} /> */}

            <Logo tab='Logo' roles={userRoles.accountConfiguration} />

            <UserManagement tab='User Management' roles={userRoles.admin} />

            <LPRSettings tab='LPR Settings' roles={userRoles.accountConfiguration} requiredFeatures={Features.PlateReads} />
            
            {/* <ActivityLog tab='Activity Log' roles={userRoles.admin} /> */}
        </Page>
    );
}

export default Settings;